'use strict';
import {find, reduce} from 'lodash';
import scriptjs from 'scriptjs';
// import Promise from 'bluebird';
let loadPromise_;

// TODO add libraries language and other map options
export default function googleMapLoader() {

    if (loadPromise_) {
        return loadPromise_;
    }

    loadPromise_ = new Promise((resolve, reject) => {

      if (window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
      }

      window._$_google_map_initialize = () => {
            delete window._$_google_map_initialize_$_;
            resolve(window.google.maps);
      };

      scriptjs(`https://maps.googleapis.com/maps/api/js?libraries=places&callback=_$_google_map_initialize`);
    });

    return loadPromise_;
}



// WEBPACK FOOTER //
// ./static/app/utils/google_map_loader.js